import React from 'react';
import SearchLinkList from '../platformui/SearchLinkList';
import SectionWrapper from '../platformui/ListContainer/section-wrapper';

export default (props) => {
  if (
    props.CurrentPageProps.PageTypeName == 'CollectionPage' ||
    props.PropertyName == 'SectionContent'
  ) {
    return (
      <SectionWrapper>
        <SearchLinkList {...props} />
      </SectionWrapper>
    );
  }
  return <SearchLinkList {...props} />;
};
